module.exports = __webpack_public_path__ + "static/img/Round-14-2015.f05ab4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-14-2015.jpg
// module id = tVEU
// module chunks = 0